<template>
  <h3 class="pb5">Sommaire du temps consacré dans les narrations par intervenant (CDX_0020)</h3>
  <CritereRechercheNarration ref="critereRechercheNarration" :cacherChamp="true"
                             :entiteDefault="entiteDefault" :siteDefault="siteDefault"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import axios from 'axios'
import {mapGetters} from "vuex";
import CritereRechercheNarration from "@/components/rapports/Rechercher/CritereRechercheNarration.vue";
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";


export default {
  name: 'sommaireTempsNarration',
  components: {CritereRechercheNarration, ButtonBar},
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Temps consacré / Narration");
    this.isRechercheDataLoading = true;

    this.$store.dispatch("dossier/obtenirSiteEntiteAction")
        .then((res) => {
          this.entiteDefault = res.data.entite;
          this.siteDefault = res.data.site;

          this.$store.dispatch("narration/rechercherDefaut48HeuresAction")
              .then((res) => {
                this.assignerResultat(res);
                this.isRechercheDataLoading = false;
              });
        });
  },

  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },

  data() {
    return {
      entiteDefault: null,
      siteDefault: null,
    }
  },

  methods: {
    assignerResultat(res) {
      this.$root.$refs.messagesComp.messagesList = res.data.messages;
      this.$refs.critereRechercheNarration.assignerListe(res.data.entiteDecision);
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      let criteresRecherche = this.$refs.critereRechercheNarration.getCriteresRecherche();
      criteresRecherche.titre = "SommaireTempsNarration";
      criteresRecherche.nomRapport = "tempsConsacre_Narration.SommaireTempsNarrationsGenerateurRapport_CDX_0020";
      this.$store.dispatch("rapports/obtenirRapportAction", criteresRecherche)
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
};
</script>